import { useApi } from '@backstage/core-plugin-api';
import { useEffect, useState } from 'react';
import {
  NotificationApi,
  notificationApiRef,
} from '../../../../apis/notificationApi';
import { permitBuildApiRef } from '../../../../apis/permitToBuildApi';

export const useTicketDetails = (ticketNumber: string, shouldcall: boolean) => {
  const notificationApi: NotificationApi = useApi(notificationApiRef);
  const permitBuildApi = useApi(permitBuildApiRef);
  const [callCounter, setCallCounter] = useState<number>(Number(shouldcall));
  const [assets, setAssets] = useState([]);

  // const [tickets, setTickets] = useState<any[]>([]);
  const [ticketDetailsLoading, setTicketDetailsLoading] =
    useState<boolean>(false);

  const getTicketDetails = async (ticketNumber: any) => {
    setTicketDetailsLoading(true);
    if (permitBuildApi) {
      try {
        const response = await permitBuildApi.getTicketDetails(ticketNumber);
        setTicketDetailsLoading(false);
        if (response) {
          setAssets(response);
        }
      } catch (error) {
        setTicketDetailsLoading(false);
        notificationApi.sendNotification({
          message: `Error occurred - ${error}`,
          disapperAfterMs: 2500,
          severity: 'error',
        });
      }
    }
    return null;
  };

  const refreshAssets = () => {
    setCallCounter(prevState => prevState + 1);
  };

  useEffect(() => {
    if (callCounter) getTicketDetails(ticketNumber);
  }, [callCounter]);

  return {
    assets,
    refreshAssets,
    ticketDetailsLoading,
  } as const;
};
